<template>
    <div>
        <v-btn-toggle
            class="text-center w-toggle-register-btn"
            v-model="toggleValue"
            @change="onInput"
            name="role"
            borderless
        >
            <v-btn value="C">
                <span class="d-none d-md-inline">Hire for a project</span>
                <span class="d-inline d-md-none">Hire</span>
            </v-btn>
            <v-btn value="D">
                <span class="d-none d-md-inline">Work as a freelancer</span>
                <span class="d-inline d-md-none">Work</span>
            </v-btn>
        </v-btn-toggle>
        <v-messages
            :value="errorsData"
            color="error"
        />
    </div>
</template>

<script>
import "~/css/shared/role-selector-buttons-group.css";

export default {
    name: "UserRoleSelector",
    data() {
        return {
            toggleValue: this.value,
            errorsData: this.errors,
        };
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        errors: {
            type: Array,
            default: ()=>[],
        },
    },
    methods: {
        onInput() {
            console.debug('on input: ', this.toggleValue);

            this.$emit('input', this.toggleValue);
        },
    },
    watch: {
        errors(newValue) {
            this.errorsData = newValue;
        }
    },
    emits: ['input'],
}
</script>

<style scoped>

</style>
